/** Border-radius tokens — design --r-1 … --r-full. */
export const Radii = {
  r1: 3, // smallest (chips)
  r2: 5, // buttons, inputs, most controls
  r3: 8, // cards
  r4: 12, // modals
  r5: 16,
  full: 999, // pills, toggles
} as const;
